import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminType } from '../enums/admin-type.enum';
import { LoginRequestDto } from '../../authentication/dtos/login-request.dto';

export class AdminFormFactory {
  static createAdminForm(fb: FormBuilder, defaultAdminType: AdminType): FormGroup {
    return fb.group({
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      adminType: [defaultAdminType, Validators.required]
    });
  }

  static createAdminLegacyForm(fb: FormBuilder, loginRequestDto: LoginRequestDto): FormGroup {
    return fb.group({
      customerKey: [loginRequestDto.email, Validators.required],
      password: [loginRequestDto.password, Validators.required],
      adminType: [AdminType.admin],
      email: ["", [Validators.required, Validators.email]],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required]
    });
  }
}
